import React from "react";
import { useParams } from "react-router-dom";
import {
  IncomeFormValues,
  useIncomeFormContext,
} from "../context/form-context";
import { parseSlug } from "../utils";
import InstructionsContent from "../components/InstructionsContent/InstructionsContent";
import IncomeTaxCalculatorForm from "../components/IncomeTaxCalculatorForm/IncomeTaxCalculatorForm";

const IncomeTaxCalculator: React.FC = () => {
  const { slug } = useParams();
  const form = useIncomeFormContext();
  React.useEffect(() => {
    const parts = slug?.split("-vs-");
    let initialValues: IncomeFormValues;
    if (parts?.length == 2) {
      initialValues = {
        salary1: parseSlug(parts[0]),
        salary2: parseSlug(parts[1]),
        currentPath: "salary1",
      };
      form.setValues(initialValues);
    } else if (slug) {
      initialValues = {
        salary1: parseSlug(slug),
        salary2: {
          grossIncome: undefined,
          pensionContributions: 0,
          studentLoanPlans: [],
          isBlind: false,
          giftAid: 0,
          taxCode: undefined,
          taxYear: "23-24-jan",
        },
        currentPath: "salary1",
      };
      form.setValues(initialValues);
    }
  }, [slug]);
  return (
    <>
      <InstructionsContent />
      <IncomeTaxCalculatorForm incomeForm={form} />
    </>
  );
};

export default IncomeTaxCalculator;
